import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import styles from './SingleDateFilterInput.module.scss';

export interface SingleDateFilterInputProps {
  label: string;
  value: string;
  onChange: (date: string) => void;
  disabled?: boolean;
}

// Compact pill trigger for a single date; distinct from DateFilterInputs' from/to pair.
export const SingleDateFilterInput: React.FC<SingleDateFilterInputProps> = ({ label, value, onChange, disabled = false }) => {
  const handleChange = (date: Dayjs | null) => onChange(date ? date.format('YYYY-MM-DD') : '');

  return (
    <div className={styles.row}>
      <label className={styles.label}>{label}</label>
      <DatePicker
        value={value ? dayjs(value) : null}
        onChange={handleChange}
        disabled={disabled}
        format="YYYY-MM-DD"
        placeholder="SELECT"
        suffixIcon={null}
        className={styles.picker}
      />
    </div>
  );
};
